export const UploadAlert = ({ message, visible }) => {
  return (
    <div className={visible ? 'container-fluid text-center align-content-center' : 'container-fluid text-center align-content-center hidden'} id="alertContainer">
      <p className="m-0 py-1">
        <i className="bi bi-exclamation-octagon" /> <span id="alert">{message}</span>
      </p>
    </div>
  );
}

